import axios from "axios"

const actionGetFarms = async ({commit}, payload) => {
  let farms = await axios.get(`${process.env.VUE_APP_URL_API}/v1/farms`, {params:{creator:payload}})
  commit("SET_FARMS", farms.data);
}

const actionGetFarmsPartner = async ({commit}, payload) => {
  let farms = await axios.get(`${process.env.VUE_APP_URL_API}/v1/farms`, {params:{partner:payload}})
  commit("SET_FARMS", farms.data);
}

const actionEditFarm = async ({commit}, payload) => {
  const farm = {...payload};
  delete farm.id;
  const editedFarm = await axios.put(`${process.env.VUE_APP_URL_API}/v1/farms/${payload.id}`, {farm:farm});
  commit("SET_EDIT_FARM", editedFarm.data);
}

const actionPostFarm = async ({commit}, payload) => {
  const {partners, ...farm} = payload;
  const newFarm = await axios.post(`${process.env.VUE_APP_URL_API}/v1/farms`, {farm, partners});
  commit("SET_NEW_FARM", newFarm.data);
}

export default {
  actionGetFarms,
  actionGetFarmsPartner,
  actionEditFarm,
  actionPostFarm
}